import { render, staticRenderFns } from "./BackdoorComponent.vue?vue&type=template&id=05c7064a&"
import script from "./BackdoorComponent.vue?vue&type=script&lang=js&"
export * from "./BackdoorComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports